import { render, staticRenderFns } from "./TButton.vue?vue&type=template&id=1c1fd310&scoped=true&"
import script from "./TButton.vue?vue&type=script&lang=js&"
export * from "./TButton.vue?vue&type=script&lang=js&"
import style0 from "./TButton.vue?vue&type=style&index=0&id=1c1fd310&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c1fd310",
  null
  
)

export default component.exports